import { render, staticRenderFns } from "./ImsModal.vue?vue&type=template&id=17860290"
import script from "./ImsModal.vue?vue&type=script&lang=js"
export * from "./ImsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports